import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { useFormik, Form, FormikProvider } from "formik";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  assignSme,
  getsmeList,
  getSmoLeads,
} from "../../../../redux/features/smoSlice";
import * as Yup from "yup";
import { useSnackbar } from "notistack";

const CustomTextField = ({
  multiline,
  name,
  label,
  dataRow,
  rows,
  key,
  ...props
}) => (
  <TextField
    name={name}
    label={label}
    value={dataRow[name]}
    // onChange={formik.handleChange}'
    disabled
    fullWidth
    rows={rows}
    multiline
    // error={formik.touched[name] && Boolean(formik.errors[name])}
    // helperText={formik.errors[name]}
    {...props}
  />
);

const SMOassignation = ({ rowData, dispatchdata }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  console.log(rowData);

  const { smeList, loading } = useSelector((state) => state.smo);

  const ValidationSchema = Yup.object().shape({
    assigned: Yup.string().required("Please select a SME"),
    // remarks: Yup.string().required("please add Remarks"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      assigned_by: "",
      remarks: "",
      course_enrollment_id: rowData.course_enrollment_id,
      assigned: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(assignSme(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getSmoLeads(dispatchdata));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    dispatch(
      getsmeList({
        search: "",
      })
    );
  }, []);

  const smedemolist = [
    { id: 1, name: "Sme demo 1" },
    { id: 2, name: "Sme demo 2" },
  ];

  const textFields = [
    { name: "lead_name", label: "Name" },
    { name: "admn_no", label: "Admission Number" },
    { name: "class_name", label: "Class" },
    { name: "course_name", label: "Course" },
    { name: "lead_mob_no", label: "Contact Number" },
    // { name: "oga_name", label: "OGA Name" },
    // { name: "feepaid", label: "Fee Paid" },
    // { name: "book_and_publication", label: "Book & Publication" },
    // { name: "assigned_to", label: "Assigned To CRM" },
    // { name: "crm_status", label: "CRM Status" },
    // { name: "cro_assigned_on", label: "CRO Assigned On" },
    // { name: "student_status", label: "Student Status" },
    // { name: "sme_call_status", label: "SME Status" },
    // { name: "sme_assigned_to", label: "SME Assigned To" },
  ];

  return (
    <GlobalDialog
      title={"Assign SME"}
      open={open}
      setOpen={setOpen}
      fullWidth
      closeButton={true}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Assign SME
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  {textFields.map((item, index) => {
                    return (
                      <Box key={index}>
                        <CustomTextField
                          name={item.name}
                          label={item.label}
                          dataRow={rowData}
                        />
                      </Box>
                    );
                  })}

                  <Autocomplete
                    options={smeList}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) =>
                      formik.setFieldValue("assigned", value?.userID || "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Assign SME"
                        variant="outlined"
                        error={
                          formik.touched.assigned &&
                          Boolean(formik.errors.assigned)
                        }
                        helperText={
                          formik.touched.assigned && formik.errors.assigned
                        }
                      />
                    )}
                  />
                  <TextField
                    name="remarks"
                    value={formik.values.remarks}
                    // error={
                    //   formik.touched.remarks && Boolean(formik.errors.remarks)
                    // }
                    // helperText={formik.errors.remarks}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Remarks"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Assign"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default SMOassignation;
